export const en = {
  tabs: {
    main: 'Main',
    friends: 'Social',
    profile: 'Passport',
    tasks: 'Tasks',
    leaderboard: 'GIGI',
  },
  webappPopup: {
    error: 'Error',
    tgVersionIncompatibleSharing: 'This version of telegram does not support sharing!',
    processUnable: 'We are unable to process your request at the moment',
    noLootboxes: 'We saved your request but no cases available, please try again later',
    loginToBuy: 'You need to be logged in to buy more keys',
    needTgPremiumForStories: 'You need to be a Telegram Premium user to share stories',
    tgVersionTooOldForStories: 'Your Telegram version is too old to share stories',
    tryAgain: 'Please try again later',
    alreadyConnected: 'You already logged in!',
    ableToUpdate: 'You are able to update progress once every 24 / 12 hours for premium',
    inviteMoreFriends: 'You need to invite more friends',
    notSupportedOnDevice: 'This feature is not supported on your device',
  },
  controls: {
    close: 'Close',
  },
  pages: {
    openEgs: {
      title: 'EGS Privacy Management',
      sub: 'To enable GAMED to receive up-to-date statistics and information about your gaming legacy, you are required to open your Epic Games profile.',
      step: 'Step',
      openEgs: (onClick: () => void) => (
        <span>
          Open the Epic Games Store app or navigate to{' '}
          <span
            style={{ color: '#4A6BFC' }}
            onClick={onClick}
          >
            Epic account portal
          </span>
          .
        </span>
      ),
      myAchievements: (
        <span>
          Once logged in, click on your avatar in the top right corner of the screen and go to{' '}
          <span style={{ color: 'white' }}>”My Achievements”</span> tab.
        </span>
      ),
      threeDots: (
        <span>
          Click the three dots next to the<span style={{ color: 'white' }}> ‘Privacy Level’</span> field. Select
          <span style={{ color: 'white' }}> ‘Manage Privacy’</span>from the drop-down menu.
        </span>
      ),
      openProfile: (
        <span>
          In the ‘Manage Privacy’ section, select<span style={{ color: 'white' }}> ‘Open Profile’</span>. This allows us
          to receive information about your gaming legacy on the platform
        </span>
      ),
    },
    recommendations: {
      title: 'Recommended games',
      subtitle: "On this screen, we've put together a small collection of recommended games for you!",
    },
    onboarding: {
      title: 'Welcome to GAMED!',
      text: (
        <>
          Have you ever imagined that you will be rewarded for your <span style={{ color: 'white' }}>playtime</span> and
          in-game <span style={{ color: 'white' }}>achievements</span>?
        </>
      ),
      text2: (
        <>
          GAMED makes that dream a <span style={{ color: 'white' }}>reality</span>! We will analyse your Steam gaming
          profile and provide you with a truly <span style={{ color: 'white' }}>worthy reward</span>.
        </>
      ),
      button: 'Continue',
      buttonSecond: 'Continue without authorization',
    },
    tonConnect: {
      title: 'TON Wallet Connect',
      text: 'No Steam? Well, buddy, looks like you’ll need to connect a TON wallet to rep yourself in the ecosystem and join the fun in GAMED. Just a heads up, though—the real goodies go to those who’ve hooked up their Steam and verified their gaming prowess.',
      button: 'Connect Wallet',
      buttonSecond: 'Continue without authorization',
    },

    tggift: {
      heading: 'Telegram Gift Case already in GAMED!',
      desc: (
        <>
          <p>
            There's a new update in GAMED! We introduce a unique{' '}
            <span style={{ color: 'white' }}>Telegram Gift Case</span> where you can obtain Telegram{' '}
            <span style={{ color: 'white' }}>gifts</span> along with valuable GAMED tokens.
          </p>
          <p>
            The GAMED bot will automatically select an available gift and credit it to your account. Standard gifts can
            be upgraded to NFT in your Telegram profile!
          </p>
        </>
      ),
      notation: (
        <p>
          All received gifts can be <span style={{ color: 'white' }}>kept</span> in your profile - by default they will
          be visible to all Telegram users!
        </p>
      ),
      info: {
        title: 'Telegram Gifts!',
        desc: 'Open new case and collect memorable rewards!',
      },
    },
    main: {
      monetize: 'Monetize your play time',
      earn: 'Earn real rewards for your in-game progress',
      receive: 'Receive up-to-date stats on all your games',
      shareLegacy: 'Share your Legacy',
      last_update: 'since last update',
      inviteFriends: 'Invite Friends',
      gigiInfo:
        'GIGI (Global Index of Gamer Impact) is an AI-powered ranking system designed to measure and quantify a player’s overall influence, skill, and gaming legacy across multiple platforms.',
      share_progress: 'Share last progress',
      joinCommunity: 'Join Community',
      tgCase: 'Telegram Gift Case',
      specialEvent: 'Special Event!',
      update_progress: 'Update Progress',
      updateNow: 'Update Now',
      freeUpdate: 'Free Update:',
      timer_text: 'Next update in',
      joinGiveaway: 'Join The Giveaway',
      validateLegacy: 'Validate your gaming Legacy!',
      joinPlaytest: 'Join Farcana Playtest!',
      steamDeck: 'Steam On! Case',
      ambassador: 'Ambassador Case',
      cargo: 'CARGO Case',
      steamOn: 'Steam On!',
      arrival: 'New Arrival!',
      arrival2: 'New Arrival!',
      joinGiveaway2: 'Join the Giveaway!',
      platforms: 'Platforms',
      rewards: 'Daily rewards & cases',
      gamedRewards: 'Rewards',
      news: "What's new?",
      topUpSteam: 'Steam Top-Up',
      statuses: {
        Available: 'Available',
        Connected: 'Connected',
        Soon: 'Soon',
        Legacy: 'Legacy',
      },
      connect_button: 'Connect',
      connect_steam: 'Connect Steam',
      no_steam_account: 'I don’t have steam account',
      modal_content: `You will be authenticated directly through Steam’s official page. Your login and password remain completely confidential and are not shared with GAMED. \nWe only access your public gaming information (such as hours played and achievements) to reward you with points on our platform.`,
      modal_title: 'Steam Authorization',
      steam_modal_content: 'We won’t see your login and password!',
      // paragraph1: 'To access your GAMED stats and rewards, please link your Steam account!',
      paragraph1: (
        <span>
          To access your <span style={{ color: 'white' }}>GAMED stats</span> and{' '}
          <span style={{ color: 'white' }}>rewards</span>, please link your Steam account!
        </span>
      ),
      // paragraph2:
      //   'Authorisation is processed through the original Steam webpage, so we are unable to access your personal data and passwords.',
      paragraph2: (
        <span>
          Authorisation is processed through the original <span style={{ color: 'white' }}>Steam webpage</span>, so we
          are unable to access your personal data and passwords.
        </span>
      ),
      whatDataLink: 'What data are we using?',

      widgetText: {
        title: 'Connect your Steam account to start earning $GAMED',
        sub_title: 'Why Connect Your Steam Account?',
        list_item_1: 'Track your hours played and achievements',
        list_item_2: 'Earn $GAMED for your in-game progress',
        list_item_3: 'Compete on the leaderboard with other players',

        keysAndRewards: {
          needMoreKeys: 'Need more keys?',
          buyKeysAndUse: 'Buy keys and use them to open Cases!',
          yourKeys: 'Your Keys:',
          freeBoxIn: 'Free Box in',
          viewRewards: 'View Rewards',
          canClaim: 'Ready to Claim',
          readyToOpen: 'Ready to open!',
          keys: 'Keys',
          stars: 'Stars',
          package: 'Package',
          price: 'Price',
        },
      },

      dailyCaseBanner: {
        yourKeys: 'Your Keys:',
        freeCaseIn: 'Free case in:',
        viewRewards: 'View Rewards',
        claimReward: 'Claim Reward',
      },

      subscriptionDrawer: {
        description:
          'Get additional features and advanced account statistics, bonus GAMED & GIGI, increased daily rewards and more...',
        aldreadySubscribed: 'You are already subscribed.',
        alreadyPlus: 'GAMED Plus provides you with access to advanced stats and accelerated GAMED earnings!',
        alreadyPlatinum: 'GAMED Platinum ensures you access advanced stats and unique GIGI and GAMED earning bonuses!',
        enjoyFeatures: ' Enjoy your GAMED Plus extra features!',
        valid: 'VALID UNTIL',
        add: 'Add 500K',
        toGet: 'to get',
        discount: '30% discount',
        getPlus: 'Subscribe for ',
        later: 'Later',
        columns: {
          feature: 'Feature availabilty',
          basic: 'Basic',
          plus: 'Plus',
        },

        features: {
          // extra_update_bonus: 'Extra Update Bonus',
          // free_reroll: 'Improved drop ratios',
          // free_gamed_box: 'Free GAMED Case',
          // games_owned: 'Games Owned',
          // items_owned: 'Items Owned',
          // total_account_value: 'Total Account Value',
          // total_playtime: 'Total Playtime',
          // daily_playtime: 'Daily Playtime',
          // account_age: 'Account Age',
          // registration_date: 'Registration Date',
          // inventory_price: 'Inventory Price',
          // favorite_genre: 'Favorite Genre',
          // recommendations: 'Recommendations',

          advancedStatistics: 'Advanced statistics',
          improvedDrop: 'Improved drop ratios',
          recommendations: 'Recommendations',
          moreGigi: 'More GIGI for playtime',
          moreGamed: 'More GAMED for tasks',
          freeCase: 'Free GAMED Case',
          updateProgress: 'Update progress',
        },
      },
      newYear: {
        heading: '20 Steam Gift Cards Giveaway!',
        description: 'From January 1st to 7th, Gamed’s got some free loot for you!',
        playFavorite: 'Play your favorite games...',
        weKnow: '(we know you’re already doing that)',
        updateProgress: 'And update your progress!',
        inGamedApp: 'in your GAMED app profile',
        rules:
          'On January 7th, we’ll randomly pick 20 lucky winners and drop some sweet Steam Gift Cards (from $10 to $50) right into their accounts.',
      },
      recalculating: {
        heading: 'Recalculating the GAMED economy!',
        description:
          'In this update, we have revised the profile evaluation algorithm. But do not worry, all your GAMED will stay with you — only their number will increase!',
        notation:
          'The value of accounts hasn`t changed proportionally — we have just removed the fractional parts in the account valuation to make your experience better.',

        stats: {
          valueChanged: 'Your account value has been recalculated with a new algorithm',
          openedBoxes:
            'If you opened a GAMED Case in the previous updates, you will be rewarded with a fair compensation',
        },
      },
    },
    profile: {
      shareLegacy: 'Share your Legacy',
      games4u: 'Games for you',
      meet: 'MEET THE',
      privateAccount: 'Private Account',
      addFriend: 'Add Friend',
      removeFriend: 'Remove Friend',
      status: 'connected successfully',
      total_steam_value: 'ACCOUNT VALUE',
      balance: 'REWARD',
      updateIn: 'Next Update in',
      updating: 'Updating...',
      now: 'Now',
      gamingLegacy: 'Your Gaming Legacy',
      externalGamingLegacy: 'Gaming Legacy',
      private: 'Private Account',
      expensiveItems: 'Most Expensive Items',
      lastUpdate: 'Last Update:',
      totalAssets: 'TVGA',
      rewards: 'Rewards',
      updateProgress: 'Update Progress',
      favoriteGames: 'Favorite Games',
      tabs: {
        overview: 'Overview',
        games: 'Games',
        items: 'Inventory',
      },
      unifiedStats: {
        totalAccVal: 'Total Accounts Value',
        totalAssPur: 'Total Assets Value',
        totalHrPlayed: 'Total Hours Played',
        dailyPlaytime: 'Daily Playtime',
        gamesOwned: 'Games Owned',
        itemsOwned: 'Items Owned',
      },
      overview: {
        games_owned: 'Games owned',
        items_owned: 'Items owned',
        total_hours_played: 'Total Playtime',
        account_value: 'Account Value',
        account_age: 'Account Age',
        inventory_price: 'Assets Purchased',
        registration_date: 'Registration Date',
        daily_playtime: 'Daily Playtime',
        favorite_genre: 'Favorite Genre',

        features: 'Features',
        recomended: 'Recomended',
        recommendedGames: 'Recommended Games',
      },
      gameList: {
        unit: 'H',
      },
      itemsList: {
        error: 'No items',
      },

      stories: {
        meetThe: 'MEET THE',
        mainStories: {
          connectedPlatforms: 'Connected Platforms',
          stats: {
            totalPlaytime: 'Total Playtime',
            accountsValue: 'Accounts Value',
            assetsValue: 'Assets Value',
            gamesOwned: 'Games Owned',
            itemsOwned: 'Items Owned',
            totalGigi: 'Total GIGI',
            gigiForAssets: 'GIGI for Assets',
            gigiForGames: 'GIGI for Games',
            gigiForHours: 'GIGI for Hours',
          },
        },
        lastProgress: {
          stats: {
            gamesOwned: 'Games Owned',
            itemsOwned: 'Items Owned',
            totalPlaytime: 'Total Playtime',
            accountValue: 'Account Value',
            hours: 'H',
          },
        },
        steamProfile: {
          totalGamedValue: 'MY REWARD IN GAMED',
          stats: {
            totalPlaytime: 'Total playtime',
            accountValue: 'ACCOUNT VALUE',
          },
        },
      },
    },

    farcanaProfile: {
      rewards: 'Rewards',
      registrationLink: 'Download Farcana',
      connectedSuccessfully: '◉ Farcana account connected successfully',

      stats: {
        totalHoursPlayed: 'Total Hours Played',
        totalAssetsValue: 'Total Assets Value',
        dailyStreakLength: 'Daily Streak Length',
        registrationDate: 'Registration Date',
        totalMatchesPlayed: 'Total Matches Played',
        averageDailyPlaytime: 'Average Daily Playtime',
        KDA: 'K/D',
        winrate: 'Winrate',
      },
    },
    epicProfile: {
      connectedSuccessfully: '◉ Epic Games account connected successfully',
      favgames: 'Favorite Games',
      noGames: 'You have no games!',
      legacy: 'Your Gaming Legacy',
      stats: {
        accountValue: 'Account Value',
        gamesOwned: 'Games Owned',
        achievements: 'Achievements',
        xp: 'Experience',
      },
    },

    friends: {
      noFriends: 'You have no friends!',
      yourFriends: 'Your Friends',
      user: 'User',
      header: (props: { firstLevel: number; secondLevel: number }) => (
        <p>
          Invite friends to earn&nbsp;
          <span>{props.firstLevel && props.firstLevel != 10 ? <div>{props.firstLevel}%</div> : '10%'}</span>
          &nbsp;of their rewards, plus&nbsp;
          <span>{props.secondLevel && props.secondLevel != 5 ? <div>{props.secondLevel}%</div> : '5%'}</span>
          &nbsp;from their invites. Ensure they connect&nbsp;
          <span>Steam</span> for <span>maximum</span> rewards.
        </p>
      ),
      earned_today: 'Earned today',
      expires: 'Expires in',
      no_tokens: 'There is no tokens to claim',
      tokens_claimed: 'Tokens have been claimed',
      total_earned: 'Total earned',
      directed_friends: 'Direct friends',
      ambassadorInfo: (handleClick: () => void) => (
        <span>
          Ambassadors and Influencers can receive special benefits by contacting GAMED representatives in the{' '}
          <span
            style={{ color: '#4A6BFC' }}
            onClick={handleClick}
          >
            official chat
          </span>
        </span>
      ),
      second_lvl_friends: '2nd-Level Friends',
    },
    shop: {
      selectCurrency: 'Select currency',
      transactionSuccess: 'Transaction successfully completed.',
      transactionProcessing: 'The transaction is being processed.',
      heading: 'The Best Offers!',
      standardBundles: 'Standard Bundles',
      messageSupport: (handleClick: () => void) => (
        <span>
          If you encounter any errors or glitches in the transaction process, please contact us via{' '}
          <span
            onClick={handleClick}
            style={{ color: 'rgba(74, 107, 252, 1)', cursor: 'pointer' }}
          >
            official support-bot
          </span>
          !
        </span>
      ),
      subHeading: (
        <span>
          Buy keys and use them to open cases. For the best experience, use{' '}
          <span style={{ color: 'rgba(30, 255, 0, 1)' }}>mobile version</span> of Telegram and{' '}
          <span style={{ color: 'rgba(30, 255, 0, 1)' }}>VPN</span> to initiate TON payments!
        </span>
      ),
    },
    tasks: {
      labels: {
        daily: 'Daily',
        general: 'General',
      },
      modalText:
        'To complete the task, you need to synchronize your data. Be sure to end your current game session before updating!',

      steamOn: 'CONNECT & WIN!',
      steamOnDescription: (
        <>
          Special 14-day event with 200+ rewards for players! Open cases, complete tasks and get a chance to win{' '}
          <span style={{ color: 'white' }}>Steam Deck</span>,{' '}
          <span style={{ color: 'white' }}>PS5 Limited Edition</span> and{' '}
          <span style={{ color: 'white' }}>Steam Gift Cards</span>!
        </>
      ),
      connectNwinDesc: (
        <>
          Event with real prizes for <span style={{ color: 'white' }}>players</span>! Open cases and complete tasks to
          win <span style={{ color: 'white' }}>Steam Deck</span>,{' '}
          <span style={{ color: 'white' }}>PS5 Limited Edition</span>,
          <span style={{ color: 'white' }}>Steam Gift Cards</span> and more!
        </>
      ),
      heading: 'Tasks',
      inGame: 'In-Game tasks',
      dailyTasks: 'Daily Tasks',

      name: {
        x: 'GAMED in X (Twitter)',
        vote: 'Vote for GAMED!',
        addSteam: 'Connect Steam',
        addEpic: 'Connect Epic Games',
        gamedCommunity: 'GAMED Community',
        gamedChat: 'Join GAMED Chat',
        addToHomeScreen: 'Home screen',
        tonConnect: 'TON Connect',
        addEmoji: 'GAMED Emoji',
        boost: 'Boost!',
        openSteamOn: 'Open Steam On! Case',
        openPs5: 'Open PS 5 Limited Case',
        friends3: 'Invite 3 friends',
        friends5: 'Invite 5 friends',
        streaks: 'Streaks',
        tApps: 'Trending Apps',
        postStory: 'Share the Story',
        updateProgress: 'Update progress',
        play: 'Play ',
        friends1: 'Invite Friend',
        xPost: 'Retweet it!',
        yesCoin: 'Join the Yescoin campaign!',
        boinkersMoon: 'Send 3 Boinkers to the Moon',
        tradeStormTrade: 'Trade on StormTrade',
        boinkersSlut: 'Spine the Slot 10 times',
        pokergram: 'Play 3 Hands in Pokergram',
        tradeUpscale: 'Trade on Upscale',
        joinUpscale: 'Join Upscale in X',
      },

      description: {
        x: 'Subscribe to official channel',
        addSteam: 'Verify your achievements',
        vote: 'Vote for the project in Telegram Apps Center',
        addEpic: 'Verify your achievements',
        gamedCommunity: 'Subscribe to the community',
        gamedChat: 'Join and socialise',
        tonConnect: 'Connect your TON wallet to GAMED',
        addToHomeScreen: 'Add GAMED to your app screen',
        addEmoji: 'Add GAMED emoji to your profile',
        boost: 'Boost our Telegram channel',
        friends1: '',
        friends3: '',
        friends5: '',
        openSteamOn: '',
        openPs5: 'Optional',
        xPost: 'Share the community post in X',
        streaks: 'Join Streaks and win TON, USDT and other prizes',
        tApps: 'Explore more Web3 applications',
        play: 'Play ',
        playDesc: 'for 2 hours and update your progress',
        postStory: 'Share your progress with friends',
        updateProgress: 'Actualise statistics and get valuable rewards',
        yesCoin: 'Get a chance to win a reward!',
        boinkersMoon: '',
        tradeStormTrade: '',
        boinkersSlut: '',
        pokergram: '',
        tradeUpscale: '',
        joinUpscale: 'Subscribe to our partners!',
      },
    },

    connectPlatform: {
      egs: {
        connect_button: 'Connect',
        connect: 'Connect Epic Games Store',
        reject: 'Maybe later',
        modal_content: `You will be authenticated directly through Steam’s official page. Your login and password remain completely confidential and are not shared with GAMED. \nWe only access your public gaming information (such as hours played and achievements) to reward you with points on our platform.`,
        title: 'Epic Games Authorisation',
        securityAlert: 'Your data remains securely protected!',
        paragraph1: (
          <span>
            To access addtonal <span style={{ color: 'white' }}>stats</span> and{' '}
            <span style={{ color: 'white' }}>rewards</span>, please link your{' '}
            <span style={{ color: 'white' }}>Epic Games</span> account!
          </span>
        ),
        paragraph2: (
          <span>
            Authorisation is processed through the original{' '}
            <span style={{ color: 'white' }}>Epic Games Store webpage</span>, so we are unable to access your personal
            data and passwords.
          </span>
        ),
        whatDataLink: 'How to open EGS account?',
      },
      steam: {
        connect_button: 'Connect',
        connect: 'Connect Steam',
        reject: 'I don’t have steam account',
        modal_content: `You will be authenticated directly through Steam’s official page. Your login and password remain completely confidential and are not shared with GAMED. \nWe only access your public gaming information (such as hours played and achievements) to reward you with points on our platform.`,
        title: 'Steam Authorization',
        securityAlert: 'We won’t see your login and password!',
        paragraph1: (
          <span>
            To access your <span style={{ color: 'white' }}>GAMED stats</span> and{' '}
            <span style={{ color: 'white' }}>rewards</span>, please link your Steam account!
          </span>
        ),
        paragraph2: (
          <span>
            Authorisation is processed through the original <span style={{ color: 'white' }}>Steam webpage</span>, so we
            are unable to access your personal data and passwords.
          </span>
        ),
        whatDataLink: 'What data are we using?',
      },
      farcana: {
        connect_button: 'Connect',
        connect: 'Connect Farcana Account',
        reject: 'Maybe Later',
        modal_content: `You will be authenticated directly through Steam’s official page. Your login and password remain completely confidential and are not shared with GAMED. \nWe only access your public gaming information (such as hours played and achievements) to reward you with points on our platform.`,
        title: 'Farcana Account Connect',
        securityAlert: 'Your data remains securely protected',
        paragraph1: (
          <span>
            Step into <span style={{ color: 'white' }}>Farcana</span>, a 5v5 shooter game, where immersive gameplay
            meets high-speed and competitive hero action.
          </span>
        ),
        paragraph2: (
          <span>
            Authorisation is processed through the original <span style={{ color: 'white' }}>Farcana webpage</span>, so
            we are unable to access your personal data and passwords.
          </span>
        ),
        whatDataLink: 'What data are we using?',
      },
    },
    boxPage: {
      availableCases: 'Available cases',
      legacy: 'Legacy',
      expired: 'Expired',
      yourKeys: 'Your keys',
      tprem: 'Telegram Premium for 1 year',
      uniqueRewards: 'Unique AMBASSADOR rewards',
      showMore: 'Show me more',
      uniqueGift: 'Unique Gift',
      standardRewards: 'Basic Rewards',
      claimed: 'Claimed',
      heading: {
        cases: 'Cases',
        description: 'Description',
      },

      uniqueContent: {
        heading: 'Unique Reward',
        title: 'Partner Rewards',
        ambassadorCase: {
          uniqueRewards: 'Уникальные награды от амбассадора',
          uniqueGift: 'Подарок',
        },

        steamDeck: {
          title: 'Steam Deck',
          subTitle: 'Rush now, the number of consoles is limited!',
        },
        cityHolder: {
          title: 'Unique item',
        },
      },

      descriptions: {
        gamed: (
          <p>
            A standard case that is available for free once a day. Contains GAMED tokens that are essential for
            obtaining valuable rewards and bonuses.
          </p>
        ),
        tgGift: (
          <span>
            <p>
              This case contains random Telegram Gifts to display on your profile, trade, or gift. It also includes
              GAMED Points to boost your progress. Open it now and get your treasures!
            </p>
            <br />
            <p>Note: Telegram rewards are automatically credited to your account by the GAMED bot.</p>
          </span>
        ),
        vavilova: (
          <span>
            <p>
              In collaboration with our ambassador Yulia Vavilova we have designed a special case where you have a
              chance to win unique NFT gifts.
            </p>
            <br />
            <p>The case is available for a short time and the number of gifts is strictly limited!</p>
          </span>
        ),
        cargo: (
          <span>
            <p>
              This case contains an increased number of GAMED tokens. No need to open hundreds of standard cases - get
              everything at once in one bundle!
            </p>
            <br />
            <br />
            <p>Please note: only 100 CARGO cases are available for purchase! </p>
          </span>
        ),
        steamDeck: (
          <span style={{ margin: '0', textWrap: 'pretty' }}>
            <p style={{ textWrap: 'pretty', marginBottom: '16px' }}>
              This case contains GAMED tokens, GAMED Plus subscription vouchers (for 6 and 12 months), a voucher for a
              unique Telegram gift, and a special reward - a Steam Deck console!
            </p>
            <p style={{ textWrap: 'pretty' }}>
              Please note: the bot will automatically send you a message confirming your reward, after which GAMED
              representatives will contact you!
            </p>
          </span>
        ),
        cityholder: (
          <span style={{ margin: '0', textWrap: 'pretty' }}>
            <p style={{ textWrap: 'pretty', marginBottom: '16px' }}>
              We have teamed up with City Holder to create a unique case that gives you the chance to win partner
              rewards and GAMED tokens!
            </p>
            <p style={{ textWrap: 'pretty' }}>
              The case will be available for a short time. Please note: users without a City Holder account will only
              receive GAMED rewards. Partner rewards will be automatically credited to your City Holder account!
            </p>
          </span>
        ),
        ps5: (
          <span style={{ margin: '0', textWrap: 'pretty' }}>
            <p style={{ textWrap: 'pretty', marginBottom: '16px' }}>
              This case contains GAMED tokens, GAMED Plus subscription vouchers (6 and 12 months), a voucher for a
              unique Telegram gift, and a unique reward - a limited edition{' '}
              <span style={{ color: 'white' }}>PS 1-styled Playstation 5</span>!
            </p>
            <p style={{ textWrap: 'pretty' }}>
              Please note: the bot will automatically send you a message about your winnings, after which GAMED
              representatives will contact you!
            </p>
          </span>
        ),
        telegamApps: (
          <span style={{ margin: '0', textWrap: 'pretty' }}>
            <p style={{ textWrap: 'pretty', marginBottom: '16px' }}>
              This case is released in collaboration with Telegram Apps Centre and contains an increased number of GAMED
              points compared to the standard Gamed Case.
            </p>
            <p style={{ textWrap: 'pretty' }}>
              The case will be available for a limited time. Be sure to vote for GAMED in Telegram Apps Centre to
              support the project!
            </p>
          </span>
        ),
      },

      widgetTexts: {
        boxReady: 'GAMED Case is ready',

        lootBoxScaled: {
          limited: 'Limited',
          boxRelated: {
            trending: {
              description: (
                <p>
                  A special box created in collaboration with <span>Telegram Apps Center</span>.
                </p>
              ),
              availableFor: (
                <p>
                  Available for a <span>limited time</span> and contains <span>increased rewards</span>!
                </p>
              ),
            },
            tgGift: {
              description: <p>Get exclusive Telegram Gifts and boost your progress with GAMED Points!</p>,
              availableFor: null,
            },
            gamed: {
              description: null,
              availableFor: null,
            },
            cityholder: {
              description: (
                <span>
                  A unique case for City Holder users where you have a chance to win special rewards and GAMED-tokens!
                </span>
              ),
            },
            vavilova: {
              description: <span>A unique case where you have a chance to win limited gifts from our ambassador</span>,
              availableFor: null,
              name: (handleClick: () => void) => (
                <span
                  onClick={handleClick}
                  style={{ color: '#4A6BFC' }}
                >
                  {' '}
                  Julia Vavilova
                </span>
              ),
            },
            cargo: {
              description: <p>A strategic supply of GAMED tokens to maximize your progress!</p>,
              availableFor: null,
            },
            steamDeck: {
              description: (
                <p>
                  Grab luck by the tail and get a chance to win GAMED Plus subscription, unique Telegram gifts, and even
                  a <span style={{ color: 'white' }}>Steam Deck</span> consoles!
                </p>
              ),
            },
            ps5: {
              description: (
                <p>
                  Grab luck by the tail and get a chance to win GAMED Plus subscription, unique Telegram gifts, and even
                  a PlayStation 5 console!
                </p>
              ),
            },
            telegramApps: {
              description:
                'This special case celebrates the collaboration with the Telegram Apps Center. Contains an increased number of GAMED points!',
            },
          },
          contain: 'Contains: GAMED Points.',
          canBeOpened: 'Can be opened for free every 24 H.',
          usersWith: '',
          plusUsers: 'users get free cases twice as fast!',
          withinCase: 'Inside the case',

          modal: {
            gamed: 'Open GAMED Case?',
            trending: 'Open Trending Box?',
          },
        },

        dailyKey: {
          yourKeys: 'Your Keys:',
          grabKey: 'GRAB YOUR DAILY KEY!',
        },

        buyKey: {
          bored: 'Bored of waiting? Buy It!',
          buyKeys: 'To the shop!',
        },

        filter: {
          all: 'All',
        },

        opening: {
          heading: 'Opening GamedBox',
        },

        rewardClaim: {
          heading: 'Your Reward',
          giftWorth: 'Gift Worth',
          headingStories: 'My reward',
          reroll: 'Reroll',
          uniqueGift: 'Unique Gift',
          congrats:
            'Congratulations! You have won a unique Telegram gift from the GAMED Ambassador! The bot will send you detailed instructions on how to receive it.',

          rewardTypes: {
            Legendary: 'Legendary',
            Epic: 'Epic',
            Rare: 'Rare',
            Uncommon: 'Uncommon',
            Common: 'Common',
          },

          uniqueGifts: {
            trending: { heading: '', description: '' },
            tgGift: { heading: '', description: '' },
            gamed: { heading: '', description: '' },
            vavilova: { heading: '', description: '' },
            cargo: { heading: '', description: '' },
            steamDeck: {
              heading: 'Steam Deck',
              description:
                'Congratulations! You have won a special reward - a Steam Deck console. GAMED bot will send you detailed instructions on how to receive it.',
            },
            ps5: {
              heading: 'PlayStation 5',
              description:
                'Congratulations! You have won a unique reward - a PlayStation 5 console. The GAMED bot will send you detailed instructions on how to receive it',
            },
          },
        },
      },
    },
    news: {
      ambassador: {
        heading: 'Ambassador gifts already in GAMED!',
        description: (
          <p style={{ margin: '0', marginBottom: '12px' }}>
            In collaboration with our ambassador Yulia Vavilova we have designed a special case where you have a chance
            to win <span style={{ color: 'white' }}>unique Telegram gifts</span>.
            <br />
            <br />
            The case is available for a short time and the number of gifts is{' '}
            <span style={{ color: 'white' }}>strictly limited</span>!
          </p>
        ),
        notation: (
          <p>
            As the base rewards Ambassador Case contains <span style={{ color: 'white' }}>GAMED tokens</span> and{' '}
            <span style={{ color: 'white' }}>non-unique Telegram gifts</span>. When you receive a unique reward, the bot
            will send you a message with the transaction number, and the ambassador will{' '}
            <span style={{ color: 'white' }}>contact you personally</span> to send you a gift. Please note: GAMED
            representatives will never ask for your confidential data!
          </p>
        ),

        content: {
          heading: 'Ambassador Case',
          description: 'Open new case and get memorable rewards!',
        },
      },

      steamOn: {
        heading: 'Connect & Win!',
        description: (
          <span>
            Special 14-day event with 200+ rewards for players! Open cases, complete tasks and get a chance to win{' '}
            <span style={{ color: 'white' }}>Steam Deck</span>,{' '}
            <span style={{ color: 'white' }}>PS5 Limited Edition</span> and{' '}
            <span style={{ color: 'white' }}>Steam Gift Cards</span>!
          </span>
        ),

        notation: (
          <>
            <div style={{ marginBottom: '6px' }}>
              <span style={{ color: 'white' }}>Main rewards:</span> Steam Deck, PS5 Pro 30th Year Edition, 100× $10
              Steam Gift Cards
            </div>
            <div style={{ marginBottom: '6px' }}>
              <span style={{ color: 'white' }}>Top CS Skins:</span> Skeleton Knife (Stained), Shadow Daggers, AK Blue
              Laminate, Slate, Legion of Anubis.
            </div>
            <div style={{ marginBottom: '6px' }}>
              Winners will be selected within 3 days after the event ends and announced in the GAMED community — make
              sure to follow us!
            </div>
            <div style={{ marginBottom: '6px' }}>
              Tasks are available in the “Tasks” section. Join the action and loot rewards from GAMED!
            </div>
          </>
        ),
      },

      cargo: {
        heading: 'CARGO Arrived!',
        description: (
          <span>
            <p style={{ margin: '0' }}>
              New update in GAMED! Especially for the <span style={{ color: 'white' }}>most loyal fans</span> we
              introduce long-awaited CARGO Case. It contains an <span style={{ color: 'white' }}>increased number</span>{' '}
              of GAMED tokens.
            </p>
            <p>
              No more need to open hundreds of standard cases - get <span>everything at once</span> in one set!{' '}
            </p>
          </span>
        ),
        notation: (
          <p>
            Please note: <span style={{ color: 'white' }}>only 100</span> CARGO cases are available for purchase!{' '}
          </p>
        ),
        content: {
          heading: 'CARGO Case',
          description: 'Open new case and get memorable rewards!',
        },
      },

      steamDeck: {
        heading: 'Steam On! Case in GAMED!',
        description: (
          <span>
            <p style={{ marginTop: '0px' }}>
              GAMED is launching a unique promotion where the most loyal fans of the platform have a chance to win their
              own <span style={{ color: 'white' }}>Steam Deck</span> console!
            </p>

            <p>
              The case is available for a short time and the number of gifts is{' '}
              <span style={{ color: 'white' }}>strictly limited!</span>
            </p>
          </span>
        ),
        notation: (
          <span>
            <p>
              As the base rewards Steam On! Case contains <span style={{ color: 'white' }}>GAMED tokens</span> and{' '}
              <span style={{ color: 'white' }}>unique Telegram gifts</span>. When you receive a Steam Deck voucher, the
              bot will send you a message with the transaction number, and the GAMED representative will contact you
              personally to send you a gift.
            </p>
            <p>
              Please note: GAMED representatives will <span style={{ color: 'white' }}>never</span> ask for your
              confidential data!
            </p>
          </span>
        ),
        content: {
          heading: 'Steam On! Case',
          description: 'Open new case and get a chance to win gaming console!',
        },
      },
      playtest: {
        heading: 'Farcana Playtest News Screen',
        description: (
          <>
            <p style={{ margin: '0px' }}>
              We are ready for active expansion and proudly introduce <span style={{ color: 'white' }}>Farcana</span>{' '}
              connection, a free multiplayer game in a sci-fi setting.
            </p>
            <p style={{ margin: '12px 0px' }}>
              Farcana Connection is already available in the <span style={{ color: 'white' }}>Platforms section</span>.
              Be aware that during the playtest you can take part in a{' '}
              <span style={{ color: 'white' }}>daily marathon</span>, which is available in the ‘Tasks’ section.
            </p>
            <p style={{ margin: '0px' }}>
              The luckiest player to close the seven-day streak will receive a{' '}
              <span style={{ color: 'white' }}>limited edition PS 1-styled Playstation 5</span> !
            </p>
          </>
        ),

        notation: <p>Please note: GAMED representatives will never ask for your confidential data!</p>,
      },
      cityholder: {
        heading: 'City Holder rewards already in GAMED!',
        notation: (handleClick: () => void) => (
          <span>
            <p>
              GAMED launches collaboration with{' '}
              <span
                onClick={handleClick}
                style={{ color: '#4A6BFC' }}
              >
                City Holder
              </span>{' '}
              - Telegram's first Build-to-Earn game!
            </p>
            <p>
              Especially for new users, we have developed a case where, in addition to GAMED tokens, you can receive{' '}
              <span style={{ color: 'white' }}> unique rewards</span> for the City Holder app that will provide
              increased income and population growth.
            </p>
            <p>
              In-game City Holder items are automatically credited to the owner's account upon receipt, and each partner
              reward can only be received <span style={{ color: 'white' }}>once</span> by a user!
            </p>
          </span>
        ),
      },
      gigi: {
        heading: 'GIGI for hours, games and assets!',
        notation: (
          <span>
            <p>
              GAMED has a new update! We are introducing{' '}
              <span style={{ color: 'white' }}>GIGI (Global Index of Gamer Impact)</span> - a unique tool for evaluating
              the gaming legacy of gamers.
            </p>
            <p>
              Previously, we used GAMED tokens to evaluate <span style={{ color: 'white' }}>gaming activity</span>, but
              over time these tokens got 'lost' among the bonuses for completing tasks, opening cases and inviting
              friends. As a result, GAMED users <span style={{ color: 'white' }}>no longer care</span> about their
              in-game progress.
            </p>
            <p>
              GIGI allows us to return to the <span style={{ color: 'white' }}>original idea</span>. These index points
              cannot be bought or obtained by opening loot boxes; they are awarded exclusively for gaming legacy (games,
              items, time) and serve as an excellent
              <span style={{ color: 'white' }}> basis for building a leaderboard</span>.
            </p>
            <p>
              In turn, GAMED tokens will not lose any of their value. We are fully prepared to open up the possibility
              of their <span style={{ color: 'white' }}>utilization</span>. Stay tuned for the next update!
            </p>
          </span>
        ),
      },
      egs: {
        heading: 'Подключение Epic Games в GAMED!',
        notation: (
          <span>
            <p>
              New update in GAMED! We are pleased to announce a new algorithm for analysing{' '}
              <span style={{ color: 'white' }}>Epic Games</span> accounts! The connection is already available in the
              <span style={{ color: 'white' }}> 'Platforms'</span> section of the main screen, and progress updates are
              performed simultaneously with other connected platforms.
            </p>
            <p>
              Please note: we are only processing data from <span style={{ color: 'white' }}>open accounts</span> and
              the algorithm is still being optimised. In addition, due to EGS's strong anti-bot protection, some users
              will inevitably experience connection failures.
            </p>
            <p>Move on to new conquests together with GAMED!</p>
          </span>
        ),
      },
      ps5: {
        heading: 'PS 5 Limited Case in GAMED!',
        description: (
          <span>
            <p style={{ marginTop: '0px' }}>
              We're continuing our ride of unprecedented generosity and introducing a new case at GAMED where you have
              the chance to win a PlayStation 5 console in unique retro PS1 styling!
            </p>
          </span>
        ),
        notation: (
          <span>
            <p>
              As the base rewards PS 5 Limited Case contains GAMED tokens and unique Telegram gifts. When you receive a
              Steam Deck voucher, the bot will send you a message with the transaction number, and the GAMED
              representative will contact you personally to send you a gift.
            </p>
            <p>Please note: GAMED representatives will never ask for your confidential data!</p>
          </span>
        ),
        content: {
          heading: 'PS 5 Limited Case',
          description: 'Open a new case and win limited-edition console!',
        },
      },
      telegramApps: {
        heading: 'Vote for GAMED!',
        description: (
          <>
            <p>
              GAMED is participating in the Telegram Apps Center voting, and right now we need the support of the
              community! Your vote is a contribution to the development of the project and a huge boost for
              functionality, content and activity within the app. We take into account all suggestions, ideas and
              requests, and this vote will help us realise our plans like nothing else!
            </p>
            <p>Voting will only take a couple of seconds, but it makes a huge difference.</p>
            <p>
              In honour of the vote, we've also released a new case - it's already available in the app and contains an
              increased number of GAMED points.
            </p>
          </>
        ),
      },
    },

    leaderboard: {
      header_tabs: {
        time: 'Hours',
        account_value: 'Assets',
        token_balance: 'Points',
      },
      total_value: 'Total Value Of Gamers Assets',
      you: 'You',
      name: 'Name',
      units: {
        hours: 'total hours played',
        assets: 'value',
        gamed: 'gamed',
        gigi: 'gigi',
      },
    },
    authPage: {
      data_using: {
        heading: 'What data are we using?',
        parapraph:
          'To provide you with detailed and insightful gaming statistics, GAMED securely accesses specific public data from your Steam account. ',
        what_we_collect: 'Here’s what we collect and display:',
        privacy_policy: {
          for_more_info: 'For more information, please refer to our',
          privacy_policy: 'Privacy Policy',
          terms_of_service: 'Terms of Service',
          and: 'and',
        },
        titles: {
          profile_information: 'Profile Information',
          game_library: 'Game Library',
          playtime: 'Playtime',
          inventory: 'Inventory',
          privacy_first: 'Privacy First',
        },

        descriptions: {
          profile_information:
            'Your username, profile picture, and public profile status to personalize your GAMED experience.',
          game_library: 'A list of games you own to generate accurate statistics and insights about your collection.',
          playtime: 'Hours played in each game to showcase your gaming habits and highlight your top titles.',
          inventory: 'Information about your in-game items and their approximate market value, if publicly available.',
          privacy_first:
            'We only access public data that you’ve chosen to share through your Steam profile. None of your private information, passwords, or sensitive details are collected or stored.',
        },
      },
    },
    updatePage: {
      meet: 'MEET THE',
      got_reward: 'Your reward is credited to your account',
      no_reward: 'You did no progress. No coins for you now',
      account_age: 'Account age',
      games_owned: 'Games owned',
      items_owned: 'Items owned',
      account_value: 'Account value',
      total_hours_played: 'total H Played',
      total_playtime: 'Total Playtime',
      inventory_price: 'Inventory price',
      total_value: 'Your reward in gamed',
      most_expensive: 'Most expensive',
      new_most_expensive: 'New expensive items',
      calculating: 'Calculating...',
    },

    topUpSteamPage: {
      heading: 'Top Up Steam',
      step: 'Step',
      firstStep: {
        chooseCountry: 'Choose your country',
        steamLogin: 'Steam Login',
        amount: 'Amount',
        willReceive: 'Will receive, STEAM',
        minimalPaymentAmount: (min: number = 0.25, max: number = 200) =>
          `Min. replenish amount: ${min} STEAM USD, \nMax. replenish amount ${max} STEAM USD`,
      },

      secondStep: {
        aboutToPay: 'You’re about to pay',
        selectMethod: 'Select Payment Method',
      },

      countries: {
        ru: 'Russia',
        us: 'USA',
        ir: 'Iran',
        ua: 'Ukraine',
        id: 'Indonesia',
        ae: 'UAR',
        tr: 'Turkey',
        fr: 'France',
        es: 'Spain',
        vn: 'Vietnam',
        uz: 'Uzbekistan',
        de: 'Germany',
        pl: 'Poland',
        it: 'Italy',
        kz: 'Kazakhstan',
      },
    },
    transactionStatus: {
      headings: {
        fetching: 'Validation...',
        PAID: 'The operation was successful!',
        FAILED: 'Error!',
        wentWrong: 'Oops! Something is wrong',
        PENDING: 'Verification Pending...',
      },

      descriptions: {
        fetching: 'Your transaction is being processed. Do not close this window until the payment has been confirmed!',
        PAID: 'Wait for the funds to be cridited to your Steam account',
        FAILED: 'An error occured while completing the transaction! Try again or contact our support',
        wentWrong: 'Please try again',
        PENDING:
          'We are preparing all necessary for payment validation. Do not close this page until the confirmation is completed!',
      },
    },

    transactionHistory: {
      heading: 'Purchase History',
      paymentsWrapper: {
        steamAccount: 'Steam account',
        pending: 'Pending',
        error: 'Error',
        successful: 'Successful',
        status: 'Status:',
        refunded: 'Refunded',
      },
    },
    dailyBonus: {
      day: 'day',
      keys: 'Keys',
      key: 'Key',
      playStation: '6 month of GAMED plus& Chance to Win PS5',
      claimed: 'Claimed',
      default: {
        plusRewards: 'Rewards',
        freeRewards: 'FREE Rewards',
        heading: 'GAMED Daily Bonus',
        dailyRewards: 'Daily Login Rewards',
        nextUnlock: 'Next unlock:',
        claim: 'Claim!',
        subHeading: 'Don’t miss a day to keep your streak alive!',
      },
      farcana: {
        hardwareHeading: 'PlayStation®5 Limited Edition',
        hardwareDescription: <span>The number of consoles is limited!</span>,
        heading: 'Farcana Playtest Event',
        subHeading: 'Receive unique rewards!',
        panelHeading: 'Farcana Playtest Event',
      },
    },

    connection: {
      slide_1: {
        title: 'Unfortunately we can’t',
      },
      slide_2: {
        title: 'But...',
      },
      slide_3: {
        title: `You ll never lose the experience you ve gained`,
      },
    },
    errors: {
      private: {
        title: 'It seems your account is private',
        sub_title: 'Follow instructions below to make your profile public',
        text_w_link: (
          <p>
            From the “Steam” tab in the upper left corner of the screen, navigate to “settings”, then click “privacy
            settings”.
            <br /> <u>All Options</u> in this tab should be changed to “public”
          </p>
        ),
        private: 'private',
        manage_settings: 'Manage Steam Settings',
        public: 'public',
        my_profile: 'My Profile',
        refresh: 'Refresh',
        will_enalbe: 'This will enable all the stats to be visible to GAMED!',
        settings: {
          inventory: 'Inventory',
          details: 'Basic Details',
          friends: 'Friends List',
          game: 'Game Details',
        },

        list_title: 'Alternatively, you can navigate to the Profile Privacy Settings page manually:',
        list_item_1: 'From your Steam Profile, click the Edit Profile link under your displayed badge.',
        list_item_2: 'Click the My Privacy Settings tab',
        list_item_3: `Select your privacy state (any settings changed are saved automatically)`,
        btn_text: 'Try Again',
      },

      smth_went_wrong: {
        title: 'Oops...',
        sub_title: 'It seems something went wrong.',
        text: 'No panic! Just chill and try again.',
        tip: (
          <p>
            Check out GAMED <a href="https://t.me/gamedcommunity">Announcement Channel</a> for the latest news or ask
            users in <a href="https://t.me/gamedchaten">Chat</a>
          </p>
        ),
        btnText: 'Try Again',
      },

      doubleConnection: {
        steam: {
          heading: 'Connection Failed',
          description: 'This Steam account is already linked to another Telegram profile.',
          twice: 'You can’t use it twice.',
          connect_another: 'Connect another',
          continue_withiout: 'Continue without steam',
        },
        farcana: {
          heading: 'Connection Failed',
          description: 'This Farcana account is already linked to another Telegram profile.',
          twice: 'You can’t use it twice.',
          connect_another: 'Connect another',
          continue_withiout: 'Return to main screen',
        },
        egs: {
          heading: 'Connection Failed',
          description:
            'This Epic Games Store account is already linked to another Telegram profile.You can’t use it twice.',
          twice: 'You can’t use it twice.',
          connect_another: 'Connect another',
          continue_withiout: 'Continue without epic games',
        },
      },
    },
    btnTexts: {
      continue: 'Continue',
      next: 'Next',
      back: 'Back',
      start: 'Start',
      stop: 'Stop',
      update: 'Update',
      share: 'Share to Stories',
      share2: 'Share',
      profile: 'Show my profile',
      invite: 'Invite friends',
      claim: 'Claim',
      done: 'Done',
      check: 'Check',
      time: 'Jump into GAMED!',
      buyKeys: 'Buy more Keys',
      use: 'Use',
      buy: 'Buy',
      open: 'Open',
      openBox: 'Open',
      openGiftCase: 'Open Case!',
      openNow: 'Open Now',
      key: 'Key',
      claimKey: 'Claim',
      openCase: 'Open the case!',
      openMore: 'Open More',
      close: 'Close',
      pay: 'Pay',
      receive: 'Receive',
      completeTasks: 'Complete Unique Tasks',
      participate: 'Participate!',
      towardsVictories: 'Towards new victories!',
      voteNow: 'Vote Now!',
      updateProgress: 'Update Progress',
    },

    units: {
      dollar: '$',
      hours: 'H',
      days: 'D',
      minutes: 'M',
      years: 'Y',
      year: 'Year',
      months: 'Months',
      gamed: 'GAMED',
      gigi: 'GIGI',
      value: 'Value',
    },
  },
  news: {
    gigi: {
      preview: {
        title: 'GIGI Index',
        description: 'New Update!',
      },
    },
    egs: 'New platform in GAMED!',
    playstation: 'PS5 Case in',
  },
}
